import { styled } from "styled-components";
import { colors, measures } from "../lib/ui";

export const StyledTitle = styled.div<{ $isInPortrait: boolean }>`
    align-items: center;
    align-self: center;
    /* textSafe blue: 7:1 on white (AAA) — theme.active #007ACC is 4.0:1 */
    color: ${colors.textSafe.blue};
    display: flex;
    font-family: ${props => props.theme.font};
    height: 100%;
    width: 100%;
    justify-content: space-between;
    padding-inline: ${props => props.$isInPortrait ? measures.dialogPanel.portrait.margin : measures.dialogPanel.landscape.margin};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid ${props => props.theme.navigationFrame};

`;
